const AUTH_RETURN_URL_KEY = 'phia.auth.returnUrl';
const AUTH_REAUTHENTICATION_KEY = 'phia.auth.reauthenticationInProgress';
const AUTH_ERROR_PATHS = new Set(['/error-permisos', '/error-usuario']);

const normalizeReturnUrl = (value: string): string | undefined => {
  try {
    const parsed = new URL(value, window.location.origin);
    if (parsed.origin !== window.location.origin || !parsed.pathname.startsWith('/') || parsed.pathname.startsWith('//')) {
      return undefined;
    }

    if (AUTH_ERROR_PATHS.has(parsed.pathname)) return undefined;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return undefined;
  }
};

export const getCurrentReturnUrl = (): string => (
  `${window.location.pathname}${window.location.search}${window.location.hash}`
);

export const saveAuthReturnUrl = (value = getCurrentReturnUrl()): void => {
  const normalizedUrl = normalizeReturnUrl(value);
  if (!normalizedUrl || normalizedUrl === '/') return;

  try {
    if (!sessionStorage.getItem(AUTH_RETURN_URL_KEY)) {
      sessionStorage.setItem(AUTH_RETURN_URL_KEY, normalizedUrl);
    }
  } catch {
    // sessionStorage can be unavailable in private browsing contexts.
  }
};

export const consumeAuthReturnUrl = (): string | undefined => {
  try {
    const value = sessionStorage.getItem(AUTH_RETURN_URL_KEY);
    sessionStorage.removeItem(AUTH_RETURN_URL_KEY);
    return value ? normalizeReturnUrl(value) : undefined;
  } catch {
    return undefined;
  }
};

export const beginAuthReauthentication = (): boolean => {
  try {
    if (sessionStorage.getItem(AUTH_REAUTHENTICATION_KEY) === 'true') return false;
    sessionStorage.setItem(AUTH_REAUTHENTICATION_KEY, 'true');
    return true;
  } catch {
    return true;
  }
};

export const clearAuthReauthentication = (): void => {
  try {
    sessionStorage.removeItem(AUTH_REAUTHENTICATION_KEY);
  } catch {
    // sessionStorage can be unavailable in private browsing contexts.
  }
};
